// @ts-nocheck
import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    createTemplateRequest: ['payload'],
    createTemplateSuccess: ['payload'],
    createTemplateFailure: null,
    openTemplateDrawer: ['payload'],
    closeTemplateDrawer: null,
    updateTemplateFormField: ['payload'],
    resetTemplateFormFields: null,
    getTemplatesRequest: ['params'],
    getTemplatesSuccess: ['payload'],
    getTemplatesFailure: null,
    getTemplateRequest: ['params'],
    getTemplateSuccess: ['payload'],
    getTemplateFailure: null,
    setLatestTemplateId: ['payload'],
    openActionOptionDrawer: null,
    closeActionOptionDrawer: null,
    editTemplate: ['payload'],
    updateTemplateRequest: ['params', 'payload'],
    updateTemplateSuccess: ['payload'],
    updateTemplateFailure: null,

    openTemplateConfirmationModal: ['payload'],
    closeTemplateConfirmationModal: null,
    deleteTemplateRequest: ['params'],
    deleteTemplateSuccess: null,
    deleteTemplateFailure: null,

    cloneTemplateRequest: ['params'],
    cloneTemplateSuccess: ['payload'],
    cloneTemplateFailure: null,

    updateTemplatePageNumber: ['payload'],
    updateTemplatePerPage: ['payload'],

    updateTemplateSortFields: ['payload'],

    createResourceCodeRequest: ['payload', 'data'],
    createResourceCodeSuccess: ['payload'],
    createResourceCodeFailure: null,

    getResourceCodesRequest: ['params'],
    getResourceCodesSuccess: ['payload'],
    getResourceCodesFailure: null,

    getResourceTypeRequest: ['params'],
    getResourceTypeSuccess: ['payload'],
    getResourceTypeFailure: null,

    editResourceCode: ['payload'],
    updateResourceCodeRequest: ['params', 'payload'],
    forceUpdateResourceCodeRequest: ['params', 'payload'],
    updateResourceCodeSuccess: ['payload'],
    updateResourceCodeFailure: ['payload'],

    openResourceCodeDrawer: null,
    closeResourceCodeDrawer: null,
    updateResourceCodeFormField: ['payload'],
    updateResourceCodeDynamicFormField: ['payload'],
    resetResourceCodeFormFields: null,

    openConfirmationModal: ['payload'],
    closeConfirmationModal: null,
    deleteResourceCodeRequest: ['params'],
    deleteResourceCodeSuccess: null,
    deleteResourceCodeFailure: null,

    updatePageNumber: ['payload'],
    updatePerPage: ['payload'],

    updateSortFields: ['payload'],

    openNoteModal: ['payload'],
    closeNoteModal: null,
    updateNoteMessage: ['payload'],
    createNoteRequest: ['payload'],
    createNoteSuccess: ['payload'],
    createNoteFailure: ['payload'],
    editNote: ['payload'],
    updateNoteRequest: ['params', 'payload'],
    updateNoteSuccess: ['payload'],
    updateNoteFailure: null,
    deleteNoteRequest: ['params'],
    deleteNoteSuccess: ['payload'],
    deleteNoteFailure: null,

    openAlertModal: ['payload'],
    closeAlertModal: null,
    updateAlertMessage: ['payload'],

    openDynamicFieldDrawer: ['payload'],
    closeDynamicFieldDrawer: null,

    updateDynamicFieldFormField: ['payload'],

    addDynamicFieldRequest: ['params', 'payload', 'data'],
    addDynamicFieldSuccess: ['payload'],
    addDynamicFieldFailure: null,

    editDynamicField: ['payload'],

    openDynamicFieldConfirmationModal: ['payload'],
    closeDynamicFieldConfirmationModal: null,
    deleteDynamicFieldRequest: ['params', 'payload'],
    deleteDynamicFieldSuccess: ['payload'],
    deleteDynamicFieldFailure: null,
  },
  { prefix: 'RESOURCE_CODE/' },
);

export default Creators;
